import React, { Suspense, lazy, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';

import { Route, Switch } from 'react-router-dom';
import Loading from '../../../cisview/oldWebShared/aip/loading';
import { rootPath as corrMonitorPath, fallbackPath as assetViewPath} from '../../../assetView/redux/routing/util/routepath';
import { identify } from '../../../util/analytics/segment';
import {
	getCustomer,
	getUserName,
	getUserUUID,
	getEmail,
	hasCognitoGroupName
} from '../../../util/user';
import { AWS_GROUP_NAMES } from '../../../util/permissions/constants';

import {
	AppAccount,
	DevAppSelect,
	AppScanline,
	AppCISView,
	AppFieldLine,
	DataIntegrity,
	AppChargeLine,
	AppAssetView,
	AppLiveLine,
	AppVideoLine,
	AppTemplateBuilder,
	AppSettings,
	DashboardsAndReports,
	WebsiteBridge,
	Applications
} from './LazyLoading';
import LeftPanel from '../LeftPanel';

import { selectApplications } from '../../redux/selector';
import { add } from 'lodash';

const Admin = lazy(() =>
	import(/* webpackChunkName: "Admin" */ '../../../admin')
);

const MainRouter = () => {
	const applications = useSelector(selectApplications);

	const appAccess = useMemo(() => {
		return applications.reduce((acc, app) => {
			acc[app.url.toLowerCase()] = app;
			return acc;
		}, {});
	}, [applications]);

	identify(getUserUUID(), {
		customer: getCustomer(),
		username: getUserName(),
		email: getEmail()
	});
	return (
		<>
			<Suspense fallback={<Loading title="Loading..." />}>
				<Switch>
					<Route path="/Account" component={AppAccount} />

					{/* CORR LOADER */}
					{appAccess['corrloader'] && (
						<Route path="/CorrLoader" component={AppCISView} />
					)}
					{appAccess['corrloader'] && (
						<Route path="/CISLine" component={AppCISView} />
					)}


					{/* CORR LOGIX */}
					{appAccess['corrlogix'] && (
						<Route path="/CorrLogix" component={AppScanline} />
					)}
					{appAccess['corrlogix'] && (
						<Route path="/Scanline" component={AppScanline} />
					)}


					{/* CORR LOGIX DATA */}
					{appAccess['corrlogixdata'] && (
						<Route path="/CorrLogixData" component={AppFieldLine} />
					)}
					{appAccess['corrlogixdata'] && (
						<Route path="/Fieldline" component={AppFieldLine} />
					)}
					{appAccess['corrlogixdata'] && (
						<Route path="/FieldlineReact" component={AppFieldLine} />
					)}


					{/* CORR MONITOR */}
					{appAccess['corrmonitor'] && (
						<Route path={corrMonitorPath} component={AppAssetView} />
					)}
					{appAccess['corrmonitor'] && (
						<Route path={assetViewPath} component={AppAssetView} />
					)}



					<Route path="/dataintegrity" component={DataIntegrity} />
					{appAccess['chargeline'] && (
						<Route path="/ChargeLine" component={AppChargeLine} />
					)}
					{appAccess['liveline'] && (
						<Route path="/LiveLine" component={AppLiveLine} />
					)}
					{appAccess['videoline'] && (
						<Route path="/VideoLine" component={AppVideoLine} />
					)}
					<Route path="/templateBuilder" component={AppTemplateBuilder} />
					<Route path="/CustomerUsers" component={AppSettings} />
					<Route path="/AppList" component={Applications} />
					<Route
						path="/dashboards-and-reports"
						component={DashboardsAndReports}
					/>

					{(hasCognitoGroupName(AWS_GROUP_NAMES.AIP_ADMINS) ||
						hasCognitoGroupName(AWS_GROUP_NAMES.CUSTOMER_ADMINS)) && (
						<Route path="/admin" component={Admin} />
					)}

					<Route path="/Index" component={WebsiteBridge} />
					<Route exact path="/" component={WebsiteBridge} />
					{/* <Route path="/websiteExperiments" component={WebsiteExperimental} /> */}
					{window.hideReactApplcations === undefined && (
						<Route path="/" component={Applications} />
					)}
				</Switch>
			</Suspense>
			<Switch>
				<Route path="/Index" component={null} />
				<Route exact path="/" component={null} />
				<Route path="" component={LeftPanel} />
			</Switch>
		</>
	);
};

export default connect()(MainRouter);
